import { store } from './../../store'
import { message } from 'antd'

export const checkExistingProject  = (name) => {
  return new Promise((resolve, reject) => {
    function checkDuplicate(name) {
      return new Promise((resolve, reject) => {
        var allNames = store.getState().projects.map(a => a.name);
        let found = allNames.filter(f => (f.toLowerCase() === name.toLowerCase()) ) 
        if(found.length > 0) resolve(true)
        else resolve(false)
      })
    }

    var user = store.getState().user;
    // console.log('user... ' , user)
    // Check User
    if(user){
      // console.log('name... ' , name)
      checkDuplicate(name).then((found) => {
        // console.log('found... ' , found)
        if(found === false) {
          resolve({ success: true, user: user});
        }
        else {
          message.error('Duplication project name found!');
          resolve({ success: false })
        }
      })
    } else {
      message.error('You can\'t create/update project without authentication!'); resolve({ success: false })
    }
  })
}


// WEBPACK FOOTER //
// ./src/components/project/util.js